import React, { Fragment } from 'react'
import HeaderDilan from './HeaderDilan'
import Topics from './Topics'

const DilanComponents = () => {
	return (
		<Fragment>
			<HeaderDilan />
			<Topics />
		</Fragment>
	)
}

export default DilanComponents
